// extracted by mini-css-extract-plugin
export default {"error":"error__3B6zU","text":"text__1osGE"};